import { UserService } from '../../services/user.services';
import { Component, ViewEncapsulation, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { LoginService } from 'src/app/core/services/login.service';

import { BalanceService } from '../../services/balance.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IdentityService } from '../../services/identity.service';
import { Subscription } from 'rxjs';
import { User } from '../../models/user';
import { RolesWeb } from '../../enums/roles.enum';
import { ImageService } from '../../services/image.service';
import { NotificationService } from '../../services/notification.service';
import { NativeBridgeService } from '../../services/native-bridge.service';
import { deviceEnvironmentId } from '../../enums/device-environment-id';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('avatar', { static: true }) avatar: ElementRef;

  private subscription: Subscription;
  readonly maxFileSize = 1048576;
  private readonly DEFAULT_IMAGE = 'assets/images/user_guest.png';

  usuario: any; //just the email string
  validate: boolean = false;
  loggedUser: User;
  profilePict = this.DEFAULT_IMAGE;
  loadingPict = true;

  name = '';
  viewBalance = false;
  clickBalance = true;
  isResponsible = true;
  isMobile = false;

  constructor(
    private router: Router,
    private identityService: IdentityService,
    private login: LoginService,
    private balanceService: BalanceService,
    private userService: UserService,
    private imageService: ImageService,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private nativeBridgeService: NativeBridgeService
  ) {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription = this.identityService.currentUser.subscribe((user) => (this.loggedUser = user));
    this.loggedUser = this.identityService.getUser();
    this.usuario = this.loggedUser.email;
    this.isResponsible = this.identityService.hasRolId(RolesWeb.RESPONSABLE);
    this.name = this.loggedUser.organismo ? this.loggedUser.organismo.nombre : this.loggedUser.email;
    this.isMobile =
      this.nativeBridgeService.getEnvironment() == deviceEnvironmentId.ANDROID ||
      this.nativeBridgeService.getEnvironment() == deviceEnvironmentId.IOS ||
      this.nativeBridgeService.getEnvironment() == deviceEnvironmentId.CLOVER;

    this.loadProfilePict();
  }

  decimalBalance() {
    return this.balanceService.getBalanceDecimal;
  }

  enteroBalance() {
    return Number(this.balanceService.getBalanceEntero)
      .toFixed(0)
      .replace(/(\d)(?=(\d{3})+\b)/g, '$1.');
  }

  cerrarSesion() {
    this.login.endSession();
  }

  changeViewBalance() {
    if (this.clickBalance) {
      this.clickBalance = false;
      this.viewBalance = !this.viewBalance;
      setTimeout(() => {
        this.clickBalance = true;
      }, 800);
    }
  }

  handleFileInput(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    if (!files || files.length === 0) return;

    this.loadingPict = true;
    const file = files[0] as File;

    this.validateFile(file);
    this.imageService.uploadImage(file).then(
      (img) => {
        this.profilePict = img;
        this.loadingPict = false;
        this.notificationService.showSuccess(this.translate('constants.update_image'));
      },
      (error) => {
        this.loadingPict = false;
        this.notificationService.showError(error.message);
      }
    );
  }

  private validateFile(file: File) {
    if (file.size > this.maxFileSize) {
      throw new Error(this.translate('pages.profile.messages.errors.img_file_size'));
    }

    if (!file.type.startsWith('image/')) {
      throw new Error(this.translate('pages.profile.messages.errors.img_file_type'));
    }
  }

  openFile(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    (this.avatar.nativeElement as HTMLInputElement).click();
  }

  toggleSaldo() {
    if (this.isResponsible) {
      this.userService.showSaldo = !this.isResponsible;
    } else {
      this.userService.showSaldo = !this.userService.showSaldo;
    }
  }

  loadProfilePict(imgSrc?: string) {
    if (this.loggedUser && !imgSrc) {
      this.loadingPict = true;
      this.imageService
        .requestProfileImage(this.loggedUser.id)
        .then((r) => {
          if (r != null) {
            this.profilePict = r;
          }
        })
        .catch((error) => console.log('Image not Found'))
        .finally(() => (this.loadingPict = false));
    } else if (imgSrc) {
      this.loadingPict = true;
      this.profilePict = imgSrc;
    }
  }

  closeSessionEventHandler(): void {
    this.login.endSession();
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }
}
